var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinktwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7362 1.1375C20.3771 0.83264 19.8132 0.788688 19.2297 1.02341H19.2288C18.6153 1.26936 1.86765 8.45321 1.18592 8.74685C1.06154 8.78986 -0.0213638 9.19385 0.0899196 10.0944C0.189981 10.9052 1.06061 11.2418 1.16628 11.2802L5.42404 12.7381C5.70645 13.6788 6.74822 17.1483 6.97826 17.8889C7.12228 18.3518 7.35606 18.9587 7.7666 19.0831C8.12663 19.2224 8.4848 19.0953 8.71671 18.9138L11.3202 16.4993L15.5218 19.7761L15.6219 19.8359C15.908 19.9621 16.1811 20.0257 16.442 20.0257C16.644 20.0257 16.8367 19.9883 17.0218 19.9126C17.6512 19.6535 17.9037 19.0541 17.9298 18.9858L21.0682 2.67022C21.2599 1.79865 20.9943 1.35539 20.7362 1.1375ZM9.17962 13.3216L7.74322 17.152L6.30682 12.364L17.3192 4.22444L9.17962 13.3216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktwo);
export default __webpack_public_path__ + "static/media/linktwo.dcbfe558b635a157526618ad27a850b7.svg";
export { ForwardRef as ReactComponent };